import * as React from 'react'

import * as plume from '@ulule/owl-kit-components/next'
import * as env from '@owl-nest/config'

import { useCurrentUser } from '../../hooks/useCurrentUser'

import { ConfigurationProvider } from '../../context/configuration/ConfigurationProvider'
import { UserDrawerProvider } from '../../context/userDrawer/UserDrawerProvider'

import { Crowdfunding } from '../../components/zones/right/Crowdfunding'
import { International } from '../../components/zones/left/International'
import { HeaderWrapper } from '../../components/HeaderWrapper'
import { MobileOnlyLogo } from '../../components/zones/center/MobileOnlyLogo'

import { HeaderProps } from '../../types'
import * as S from '../../components/style'
import { URLProvider } from '../../context/urls/URLProvider'

export function Header({
  lang,
  search,
  theme = {
    colors: {
      primary: plume.COLORS.PRIMARY_BLUE_500,
    },
  },
}: HeaderProps): React.ReactElement<HeaderProps> {
  const userConfig = env.useUserEnv()
  const userLang = lang ?? userConfig.lang
  const actualSearch = search ?? { action: `${env.ULULE_ORIGINS[userLang]}${env.DISCOVER_URL}` }

  const { user, loadUser } = useCurrentUser(userLang)

  const [isTop, setItTop] = React.useState(true)

  React.useEffect(() => {
    handleScroll()

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }

    function handleScroll(): void {
      if (window.scrollY > 0) {
        setItTop(false)
      } else {
        setItTop(true)
      }
    }
  }, [])

  return (
    <UserDrawerProvider lang={userLang}>
      <ConfigurationProvider
        configuration={{
          defaultLocale: env.DEFAULT_LOCALE,
          locale: userLang,
        }}
      >
        <URLProvider>
          <S.HeaderContent $isTop={isTop}>
            <HeaderWrapper
              centerZone={<MobileOnlyLogo siteIdentifier="ulule" />}
              leftZone={<International />}
              rightZone={<Crowdfunding search={actualSearch} loadUserExtraData={loadUser} user={user} />}
              theme={theme}
            />
          </S.HeaderContent>
        </URLProvider>
      </ConfigurationProvider>
    </UserDrawerProvider>
  )
}
